export default "__VITE_ASSET__DdX9lxfr__"